import React from 'react'

const EmploymentTestResults = () => {
  return (
    <div>EmploymentTestResults</div>
  )
}

export default EmploymentTestResults